import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {getPickupTimeDataFromSessionStorage} from "../actions/nxt-local-storage"

function SessionAndTableNbrProtectedRoute({ component: Component, ...rest }) {
  const appState = useSelector((state) => state.appState);
  const { session, securityCode } = appState;
  const pickupTime = getPickupTimeDataFromSessionStorage()&& getPickupTimeDataFromSessionStorage()

  return (
    <Route
      {...rest}
      render={(props) =>
        session.data && session.data.branch && securityCode.data && securityCode.data.tableBookingNbr ? (
          <>
          {pickupTime?
          <Component {...props} />:
          <Redirect to = {{pathname:'/pickup-time-selection'}}/>
        }
          </>
        ) : (
          <Redirect to={{ pathname: '/home/take-out/' }} />
        )
      }
    />
  );
}
export default SessionAndTableNbrProtectedRoute;
// '/scan-qr-code'
